import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

export async function getOrganizationChart() {
  try {
    const response = await authFetch(`${BACKEND_URL}/organization/chart`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const payload = await response.json().catch(() => ({}));

    return {
      success: response.ok && payload?.success === true,
      data: payload?.data ?? null,
      message: payload?.message ?? "",
    };
  } catch (error) {
    console.error("[getOrganizationChart] failed:", error);
    return {
      success: false,
      data: null,
      message: "조직도를 불러오는 중 오류가 발생했습니다.",
    };
  }
}
